// Mock data for Biggie Poppins website

export const siteData = {
  brand: "BIGGIE POPPINS",
  tagline: "Where Web3 Art Meets AI Innovation—No Cap",
  
  socials: [
    { name: "Twitter", url: "https://twitter.com", icon: "Twitter" },
    { name: "YouTube", url: "https://youtube.com", icon: "Youtube" },
    { name: "Instagram", url: "https://instagram.com", icon: "Instagram" },
    { name: "Twitch", url: "https://twitch.tv", icon: "Twitch" },
    { name: "TikTok", url: "https://tiktok.com", icon: "Music" }
  ],

  about: {
    title: "ABOUT THE VISION",
    description: "Biggie Poppins isn't just a name—it's a movement. Merging the raw energy of punk rock rebellion with cutting-edge web3 technology and AI artistry, I create experiences that challenge the status quo. From generative NFT collections to AI-powered installations, every project pushes boundaries and breaks molds.",
    stats: [
      { label: "NFT Collections", value: "12+" },
      { label: "AI Models Trained", value: "50+" },
      { label: "Community Members", value: "25K+" },
      { label: "Collaborations", value: "30+" }
    ]
  },

  portfolio: [
    {
      id: 1,
      title: "Crypto Rebels Collection",
      description: "10K generative NFT collection featuring punk-inspired characters with on-chain provenance",
      category: "Web3 Art",
      image: "https://images.unsplash.com/photo-1658963658597-58f336d455ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwYWJzdHJhY3R8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzczMjAxNzc5fDA&ixlib=rb-4.1.0&q=85",
      tags: ["NFT", "Generative", "Ethereum"]
    },
    {
      id: 2,
      title: "Neural Canvas",
      description: "AI-powered art generator trained on underground punk aesthetics and street photography",
      category: "AI Art",
      image: "https://images.unsplash.com/photo-1567461654290-5cbf3ab24b65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHx1cmJhbiUyMGdydW5nZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzMyMDE3NzR8MA&ixlib=rb-4.1.0&q=85",
      tags: ["AI", "Generative", "Machine Learning"]
    },
    {
      id: 3,
      title: "Decentralized Dreams",
      description: "Interactive web3 installation exploring the intersection of consciousness and blockchain",
      category: "Interactive",
      image: "https://images.unsplash.com/photo-1616142914433-71120bc70202?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwYWJzdHJhY3R8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzczMjAxNzc5fDA&ixlib=rb-4.1.0&q=85",
      tags: ["Web3", "Interactive", "Installation"]
    },
    {
      id: 4,
      title: "Algorithmic Anarchy",
      description: "Series of AI-generated pieces challenging traditional art market structures",
      category: "AI Art",
      image: "https://images.unsplash.com/photo-1647107047182-4404b0aa0dbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwYWJzdHJhY3R8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzczMjAxNzc5fDA&ixlib=rb-4.1.0&q=85",
      tags: ["AI", "NFT", "Experimental"]
    },
    {
      id: 5,
      title: "Smart Contract Symphonies",
      description: "Generative audio-visual NFTs that evolve based on blockchain events",
      category: "Web3 Art",
      image: "https://images.unsplash.com/photo-1662591231342-c535008f927f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx1cmJhbiUyMGdydW5nZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzMyMDE3NzR8MA&ixlib=rb-4.1.0&q=85",
      tags: ["Audio-Visual", "Smart Contracts", "Dynamic NFT"]
    },
    {
      id: 6,
      title: "Punk Protocol",
      description: "DAO governance system with punk rock ethos—community-driven, anti-establishment",
      category: "Web3 Tool",
      image: "https://images.unsplash.com/photo-1589850854371-05116dafbd22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHx1cmJhbiUyMGdydW5nZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzMyMDE3NzR8MA&ixlib=rb-4.1.0&q=85",
      tags: ["DAO", "Governance", "Community"]
    }
  ],

  blog: [
    {
      id: 1,
      title: "The Death of Gatekeepers: How Web3 Democratizes Art",
      excerpt: "Traditional art institutions are crumbling. Here's why that's a good thing and how blockchain technology is giving power back to creators.",
      date: "2025-01-05",
      readTime: "8 min",
      image: "https://images.unsplash.com/photo-1589850854371-05116dafbd22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHx1cmJhbiUyMGdydW5nZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzMyMDE3NzR8MA&ixlib=rb-4.1.0&q=85",
      category: "Web3"
    },
    {
      id: 2,
      title: "Training AI on Chaos: My Experimental Process",
      excerpt: "What happens when you feed punk rock, street art, and glitch aesthetics into a neural network? Spoiler: Magic.",
      date: "2024-12-28",
      readTime: "6 min",
      image: "https://images.unsplash.com/photo-1647107047182-4404b0aa0dbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwYWJzdHJhY3R8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzczMjAxNzc5fDA&ixlib=rb-4.1.0&q=85",
      category: "AI"
    },
    {
      id: 3,
      title: "NFT Royalties & Artist Rights: What You Need to Know",
      excerpt: "A deep dive into smart contract royalties and why they're crucial for sustaining creative careers in web3.",
      date: "2024-12-15",
      readTime: "10 min",
      image: "https://images.unsplash.com/photo-1658963658597-58f336d455ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwYWJzdHJhY3R8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzczMjAxNzc5fDA&ixlib=rb-4.1.0&q=85",
      category: "Web3"
    }
  ]
};
